import React from 'react';
import PropTypes from 'prop-types';
import styles from './EnvironmentalImpact.module.css';

// Leaf Icon
const LeafIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Leaf icon">
    <path d="M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5228 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z" fill="#12B76A" />
    <path d="M32.998 15V17C32.998 26.6274 27.6255 31 20.998 31L17.2408 30.9999C17.0786 31.912 16.998 32.907 16.998 34H14.998C14.998 32.6373 15.1138 31.3997 15.3438 30.2682C15.1133 28.9741 14.998 27.2176 14.998 25C14.998 19.4771 19.4752 15 24.998 15C26.998 15 28.998 16 32.998 15ZM24.998 17C20.5798 17 16.998 20.5817 16.998 25C16.998 25.3624 17.0012 25.7111 17.0076 26.0459C18.262 24.0684 20.099 22.5048 22.5019 21.1318L23.4942 22.8682C20.6393 24.4996 18.7455 26.3535 17.7733 28.9998L20.998 29C27.0132 29 30.8692 25.0269 30.9949 17.3877C29.6229 17.5211 28.3481 17.436 26.7754 17.2001C25.6243 17.0274 25.3988 17 24.998 17Z" fill="white" />
  </svg>
);

const EnvironmentalImpact = ({ data }) => {
  const { title, subtitle, paragraph, bullets } = data;

  return (
    <section className={styles.card} aria-labelledby="environmental-impact-title">
      <header className={styles.header}>
        <LeafIcon />
        <div>
          <h2 id="environmental-impact-title" className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      </header>
      <p className={styles.paragraph}>{paragraph}</p>
      <ul className={styles.list}>
        {bullets.map((item, idx) => (
          <li key={idx} className={styles.listItem}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z" fill="#12B76A" />
            </svg>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

EnvironmentalImpact.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    bullets: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
};

export default EnvironmentalImpact;
